@if (data(); as data) {
  <div class="bg-kz-layout-featured" data-qa="cart-excursion-item">
    <div class="border-bottom p-2">
      <div class="font-medium">{{ data.offer?.name }}</div>
      <div class="text-secondary">
        {{ data.offer?.groupName }}
        @if (data.offer?.availability?.kind) {
          · {{ data.offer.availability.kind }}
        }
      </div>
    </div>
    <div class="details-list p-2">
      <div>
        <mat-icon svgIcon="fill-calendar" color="primary" />
        {{ data.date | date }}
      </div>
      <div>
        <mat-icon svgIcon="user" color="primary" />
        {{ 'ADULTS_COUNT' | translate: { value: data.adults } }}
        @if (data.children) {
          , {{ 'CHILDREN_COUNT' | translate: { value: data.children } }}
        }
      </div>
      @if (pickup(); as pickup) {
        <div [attr.data-testid]="'cart-excursion-pickup-' + data.id">
          <mat-icon svgIcon="map-marker" color="primary" />
          {{ pickup.translate ? (pickup.text | translate) : pickup.text }}
        </div>
      }
      <div class="font-medium text-kz-primary">{{ data.totalPrice | priceFormat: data.priceCurrency }}</div>
    </div>
  </div>
}
